import React, { useState, useEffect } from "react";
import TableSearch from "../../../../../base/components/Table/tableSearch";
import Table from "../../../../../base/components/Table";
import Icon from "../../../../../base/components/Icon";
import { SearchPlaceholder } from "./MergeUsersModal";
import { LIMIT_OPTIONS } from "../../../../../base/constants/pagination";

const DEFAULT_LIMIT = 15;
const DEFAULT_OFFSET = 0;

const StepSelectTarget = ({
  selectedUserInfo,
  selectedTargetUser,
  setSelectedTargetUser,
  usersService,
}) => {
  const [offset, setOffset] = useState(DEFAULT_OFFSET);
  const [pageSize, setPageSize] = useState(DEFAULT_LIMIT);
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const limitOptions = LIMIT_OPTIONS;

  const limitProvider = {
    getValue: () => pageSize,
    setValue: (value) => {
      setPageSize(value);
      setOffset(0);
    },
  };

  const paginationProvider = {
    getValue: () => offset,
    setValue: (value) => {
      setOffset(value);
    },
  };

  const fetchUsers = async (limit, offset, searchValue = "") => {
    setLoading(true);
    try {
      const params = {
        limit,
        offset,
        q: searchValue,
      };
      const { data, pagination } = await usersService.getUsers(params);
      setUsers(data || []);
      setTotalCount(pagination?.totalCount || 0);
    } catch {
      setUsers([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(pageSize, offset, search);
  }, [pageSize, offset, search, usersService]);

  const tableColumns = [
    {
      Header: "Customer name",
      accessor: (row) => `${row.firstName} ${row.lastName}`,
      id: "fullName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "ID",
      accessor: "id",
    },
  ];

  const showPlaceholder = !loading && users.length === 0;

  const handleRowClick = (row) => {
    if (row.id !== selectedUserInfo?.id) {
      setSelectedTargetUser(row);
    }
  };

  return (
    <div>
      <p className="mb-3">Select the target user for merging.</p>
      <div
        style={{
          position: "sticky",
          top: -16,
          background: "#fff",
          zIndex: 2,
          paddingTop: 6,
          paddingBottom: 6,
        }}
      >
        <div className="d-flex">
          <div className="flex-grow-1" style={{ minWidth: 85 }}>
            <div className="mb-1 fw-bold">Source User:</div>
            <div>
              <b>Name:</b> {selectedUserInfo?.firstName || "null"}{" "}
              {selectedUserInfo?.lastName || "null"}
            </div>
            <div>
              <b>Email:</b> {selectedUserInfo?.email}
            </div>
            <div>
              <b>ID:</b> {selectedUserInfo?.id}
            </div>
          </div>
          {selectedTargetUser && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minWidth: 85 }}
            >
              <Icon
                icon="between"
                className="mx-4 between-icon"
              />
            </div>
          )}
          {selectedTargetUser && (
            <div className="flex-grow-1" style={{ minWidth: 85 }}>
              <div className="mb-1 fw-bold text-success">Target User:</div>
              <div>
                <b>Name:</b> {selectedTargetUser?.firstName || "null"}{" "}
                {selectedTargetUser?.lastName || "null"}
              </div>
              <div>
                <b>Email:</b> {selectedTargetUser?.email}
              </div>
              <div>
                <b>ID:</b> {selectedTargetUser?.id}
              </div>
            </div>
          )}
        </div>
      </div>
      <TableSearch
        className="merge-target-user-search my-3"
        search={search}
        onSearch={setSearch}
        placeholder="Search customer by ID, name, email, order ID or sample code"
      />
      {showPlaceholder ? (
        <div className="text-center text-muted py-4">
          <SearchPlaceholder />
        </div>
      ) : (
        <Table
          columns={tableColumns}
          data={users}
          totalCount={totalCount}
          limit={limitProvider.getValue()}
          offset={offset}
          paginationProvider={paginationProvider}
          isLimitEditable={true}
          limitProvider={limitProvider}
          limitOptions={limitOptions}
          showPagination={true}
          loading={loading}
          isRowClick
          rowClickHandler={handleRowClick}
          rowDisabledHandler={(row) => row.id === selectedUserInfo?.id}
        />
      )}
    </div>
  );
};

export default StepSelectTarget;
